module.exports = __webpack_public_path__ + "static/media/team-member-02.c240cc06.jpg";